import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "@/lib/apiClient";

export const Register = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const next = params.get("next") || "/dashboard";

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      await register(email, password, name);
      navigate(next);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-[80vh] items-center justify-center px-6">
      <div className="w-full max-w-sm rounded-lg border border-surface-border bg-surface-card p-8 fade-up">
        <h1 className="mb-6 font-heading text-2xl font-bold text-white">Create your account</h1>
        <form onSubmit={submit} className="space-y-4" data-testid="register-form">
          <Input required placeholder="Name" value={name} onChange={(e) => setName(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="register-name-input" />
          <Input type="email" required placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="register-email-input" />
          <Input type="password" required placeholder="Password (min 6 chars)" value={password} onChange={(e) => setPassword(e.target.value)} className="border-surface-border bg-obsidian text-white" data-testid="register-password-input" />
          {error && <p className="text-sm text-sovereign" data-testid="register-error">{error}</p>}
          <Button type="submit" disabled={loading} className="w-full bg-sovereign text-white hover:bg-sovereign/90" data-testid="register-submit-btn">
            {loading ? "Creating..." : "Sign up"}
          </Button>
        </form>
        <p className="mt-4 text-center text-sm text-slate-500">
          Already have an account? <Link to="/login" className="text-sovereign" data-testid="register-login-link">Log in</Link>
        </p>
      </div>
    </div>
  );
};
